import { isUndefined } from 'lodash';

type DataParam = { _data: number[] };

function percentRank(dataParam: DataParam, x: number, significance = 3): number {
  const { _data: data } = dataParam;
  // sort the array
  const sorted = data.map(i => parseFloat(i.toString())).sort((a, b) => a - b);
  // check if 'x' is in the array
  const isValueInArray = sorted.includes(x);
  let finalValue;
  if (isValueInArray) {
    // find the number of values in the array that are less than 'x'
    const lessThanValue = sorted.filter(i => i < x).length;
    // find the number of values greater than x
    const extraNumberOfSameValues = sorted.filter(i => i === x).length - 1;
    const greaterThanValue = sorted.filter(i => i > x).length + extraNumberOfSameValues;
    finalValue = lessThanValue / (lessThanValue + greaterThanValue);
  } else {
    let lesserValue: number | undefined;
    let greaterValue: number | undefined;
    // find the two values in sorted adjacent to the 'x' parameter
    sorted.forEach(i => {
      if (i < x) {
        lesserValue = i;
      } else if (isUndefined(greaterValue)) {
        greaterValue = i;
      }
    });
    if (isUndefined(lesserValue)) {
      return 0;
    }
    if (isUndefined(greaterValue)) {
      return 1;
    }
    const lesserRank = percentRank(dataParam, lesserValue);
    const greaterRank = percentRank(dataParam, greaterValue);
    const proportion = (x - lesserValue) / (greaterValue - lesserValue);
    finalValue = lesserRank + proportion * (greaterRank - lesserRank);
  }
  return parseFloat(finalValue.toFixed(significance));
}

export default percentRank;
